import { createContext, useEffect, useState } from "react";
import useAPI from "../api/hooks/useAPI";
import useMSSP from "../api/hooks/useMSSP";

export const POCContext = createContext({ isPOC: false });

export const POCProvider = ({ children }) => {
  const [isPOC, setIsPOC] = useState(false);
  const { checkIfPOC } = useAPI();
  const { rerenderKey } = useMSSP();
  const enablePOCCheck = process.env.REACT_APP_ENABLE_POC_CHECK === "true";

  const updatePOCStatus = () => {
    if (enablePOCCheck) {
      checkIfPOC()
        .then((response) => {
          setIsPOC(Boolean(response.data));
        })
        .catch(() => {
          setIsPOC(false);
        });
    } else {
      setIsPOC(false);
    }
  };

  // Initial check
  useEffect(() => {
    updatePOCStatus();
  }, []);

  // Re-check whenever the tenant switch is fully applied (rerenderKey changes).
  useEffect(() => {
    updatePOCStatus();
  }, [rerenderKey]);

  return (
    <POCContext.Provider value={{ isPOC }}>{children}</POCContext.Provider>
  );
};
